import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const TimeOverPopupHider = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  const hide = () => {
    setAnsweringQuestions( { isShowTimeOverPopup : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onHide : hide
  } );

};

export default TimeOverPopupHider;
